import { EWorksheetStatus } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import { useMerchantById } from '@src/api/merchants-api'
import { ErrorPage, Loader } from '@src/components'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { DEFAULT_STEP, EWorksheetStep, EWorksheetStepList } from './hooks'
import { canAccessWorksheet, getWorksheet } from './selectors'
import WorksheetStepper from './WorksheetStepper'

interface Props {
  creditApp: FilteredCreditApplication
}

const WorksheetPage = ({ creditApp }: Props) => {
  const { step } = useParams<{ step: EWorksheetStep }>()
  const navigate = useNavigate()
  const [merchant, isLoadingMerchant] = useMerchantById(creditApp.merchantId)

  const worksheet = getWorksheet(creditApp)

  if (!step || !EWorksheetStepList.includes(step)) return <Navigate to={`../worksheet/${DEFAULT_STEP}`} replace />
  if (isLoadingMerchant) return <Loader />
  if (!merchant) return <ErrorPage />
  if (!canAccessWorksheet(creditApp, merchant)) {
    if (creditApp.worksheet?.status !== EWorksheetStatus.Draft)
      return <Navigate to={`/creditapplication/${creditApp.id}/contract`} replace />
    return <Navigate to=".." replace />
  }

  return (
    <WorksheetStepper
      merchant={merchant}
      creditApp={creditApp}
      setStep={(s) => navigate(`../worksheet/${s}`, { replace: true })}
      step={step}
      worksheet={worksheet}
    />
  )
}

export default WorksheetPage
